module.exports = __webpack_public_path__ + "static/media/sample_survey9.6da3ad4b.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/sample_survey9.csv
// module id = 973
// module chunks = 0